module.exports = __webpack_public_path__ + "img/105_computergame.4b62fd30.jpg";